"use strict";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

$(document).ready(function () {
  $("#basket-login-modal").click(function () {
    $('.menu-item.account.open-right-menu').click();
  });
  $('.home-slider').slick({
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    dots: true
  });
  tippy("[data-tippy-content]");

  function msie() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return version number
      {
        return true;
      } else // If another browser, return 0
      {
        return false;
      }
  }
  /*
        Sticky Menu
     */


  var header = $('#header');
  var stickyElements = $('.sticky-element');
  var transparent = false;

  if (header.hasClass('header--transparent')) {
    transparent = true;
  }

  if ($(document).scrollTop() > 0) {
    header.addClass('header--sticky');

    if (transparent) {
      header.removeClass('header--transparent').addClass('header--dark');
    }

    stickyElements.addClass('sticky-element--sticky');
  }

  $(document).on('scroll', function () {
    if ($(document).scrollTop() > 0) {
      if (!header.hasClass('header--sticky')) {
        header.addClass('header--sticky');

        if (transparent) {
          header.removeClass('header--transparent').addClass('header--dark');
        }

        stickyElements.addClass('sticky-element--sticky');
      }
    } else {
      header.removeClass('header--sticky');

      if (transparent) {
        header.removeClass('header--dark').addClass('header--transparent');
      }

      stickyElements.removeClass('sticky-element--sticky');
    }
  }); // Language selection

  $('.locale-selector').on('click', function () {
    console.log($(this).find('.dropdown')); // $(this).find('.dropdown')[0].toggleClass('opened');
  });

  $.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^]*)').exec(window.location.href);

    if (results == null) {
      return null;
    } else {
      return results[1] || 0;
    }
  };

  if ($.urlParam('login') != null) {
    $('.menu-item.account.open-right-menu').click();
  }

  AOS.init();
  if (msie()) $("[data-aos^=fade][data-aos^=fade]").css("opacity", "1");
  $(".ajaxPost").submit(function (e) {
    var form = $(this);
    var url = form.attr('action');
    e.preventDefault();
    $.ajax({
      type: "POST",
      url: url,
      data: new FormData(this),
      processData: false,
      contentType: false,
      success: function success(data) {
        if (data.panier !== undefined) {
          // Compute totals
          var types = ['G', 'S'];
          var numProd = 0;

          for (var type = 0; type < types.length; type++) {
            for (var art = 0; art < data.panier[types[type]].articles.length; art++) {
              numProd += parseInt(data.panier[types[type]].articles[art].quantite);
            }
          }

          $("#panierNumProd").html(numProd); // Notification

          console.log(window.ajouteaupanier);
          $.notify({
            message: 'Ajouté au panier !'
          }, {
            type: 'success',
            placement: {
              from: 'bottom',
              align: 'right'
            },
            animate: {
              enter: 'animated fadeInDown',
              exit: 'animated fadeOutUp'
            }
          });
        }
      }
    });
  });

  function calculatePrice() {
    var currvalue = parseInt($("#qteconso").val()) + parseInt($("#alreadyord").val());
    var currprice = 0;
    var bars = $('.progress-bar');
    var steps = $('.progress').data('steps');
    var left = 0;
    var amountFilled = 0;
    var next = 0;
    var percent = 0;
    bars.each(function (index, element) {
      if (currvalue >= $(this).data('qtemin')) {
        currprice = $(this).data('tarif');

        if (index !== steps - 1) {
          next = $(this).next().data('qtemin');
          var previous = $(this).data('qtemin');
          percent = index / steps * 100 + (currvalue - previous) / (next - previous) * (1 / steps * 100);
        } else {
          percent = 100;
        }

        if (percent > 100) percent = 100;
      }
    });
    if (percent == 0) percent = 1;
    $("#currentPrice").html(currprice);
    $("#realbar").css({
      width: percent + "%"
    });
  }

  $("#qteconso").bind('keyup mouseup', function (e) {
    calculatePrice();
  });
  calculatePrice();
  $("#btnvalidercoordonnees").click(function (e) {
    if (!skemaVerifDispatch($('input[name=nbptsliv]:checked').val())) {
      $("#verifQuantites").modal();
      e.preventDefault();
    }
  });

  function skemaVerifDispatch(nbptliv) {
    if ($(".ptlivdiv[data-nbpt='" + nbptliv + "']").hasClass('d-none')) {
      $(".ptlivdiv[data-nbpt='" + nbptliv + "']").removeClass('d-none');
      $(".ptlivdiv[data-nbpt='" + nbptliv + "'] input").prop("required", true);
      $(".ptlivdiv[data-nbpt!='" + nbptliv + "']").addClass('d-none');
      $(".ptlivdiv[data-nbpt!='" + nbptliv + "'] input").prop("required", false);
    } // One point, no need to verify quantities


    if (nbptliv == '1') {
      $("#btnvalidercoordonnees").prop('disabled', false);
      $("#basketko").addClass('d-none');
      $("#basketok").removeClass('d-none');
      return true;
    } else {
      // Get total quantities
      var totals = {};
      $(".ptlivdiv[data-nbpt='" + nbptliv + "'] .totalquantities").each(function (e) {
        var key = $(this).data('ref') + '-' + $(this).data('decli');
        if (totals[key] === undefined) totals[key] = {
          basket: 0,
          real: 0
        };
        totals[key]['basket'] += parseInt($(this).data('qty'));
      }); // Compute totals dispatched by user

      $(".ptlivdiv[data-nbpt='" + nbptliv + "'] input.skemadispatch").each(function (e) {
        var key = $(this).data('ref') + '-' + $(this).data('decli');
        totals[key]['real'] += parseInt($(this).val() || "0");
      });
      var allok = true;

      for (var _key in totals) {
        if (totals[_key]['real'] != totals[_key]['basket']) allok = false;
      }

      if (allok) {
        //$("#btnvalidercoordonnees").prop('disabled', false);
        $("#basketko").addClass('d-none');
        $("#basketok").removeClass('d-none');
      } else {
        // $("#btnvalidercoordonnees").prop('disabled', true);
        $("#basketok").addClass('d-none');
        $("#basketko").removeClass('d-none');
      }

      return allok;
    }
  }

  $('input[type=radio][name=nbptsliv]').change(function (e) {
    skemaVerifDispatch(this.value);
  });
  $('.skemadispatch').keyup(function (e) {
    skemaVerifDispatch($('input[name=nbptsliv]:checked').val());
  });
  $("#quantitestock").change(function () {
    var max = parseInt($(this).attr('max'));
    var min = parseInt($(this).attr('min'));
    var step = parseInt($(this).attr('step'));
    var current = parseInt($(this).val());
    if (current % step != 0) current = Math.round(current / step) * step;
    if (current < min) current = min;
    if (current > max) current = max;
    $(this).val(current);
  });
  $(".basketnumber").change(function () {
    var max = parseInt($(this).attr('max'));
    var min = parseInt($(this).attr('min'));
    var step = parseInt($(this).attr('step'));
    var current = parseInt($(this).val());
    if (current % step != 0) current = Math.round(current / step) * step;
    if (current < min) current = min;
    if (current > max) current = max;
    $(this).val(current);
    var action = $(this).data('action');
    console.log(action);
  });
});
$(".search-input").on('keyup', function (e) {
  if (e.which === 13 || e.keyCode === 13) {
    window.location.replace('/search/' + searchInput.val());
    return false;
  } else {
    axios.get('/prodsearch/' + searchInput.val()).then(function (response) {
      searchResultsContainer.html('');
      var results = response.data;

      for (var _i = 0; _i < results.length; _i++) {
        var element = results[_i];
        searchResultsContainer.append('<a href="' + element.url + '" class="search-result-element">\n' + '                <i class="fas fa-arrow-right"></i>\n' + '                ' + element.reference + ' - ' + element.designation + '\n' + '            </a>');
      }

      ;
    });
  }
});
var currentPage = document.querySelector("[name~=currentpage][content]").content;
var logged = document.querySelector("[name~=logged][content]").content;

if (logged === 'true') {
  logged = true;
} else {
  logged = false;
}
/**
 * Openable elements manager (like menus or popups)
 * @type {openableElementsManager}
 */


var openableElementsManager =
/*#__PURE__*/
function () {
  /**
   * Constructor
   */
  function openableElementsManager() {
    _classCallCheck(this, openableElementsManager);

    var _oem = this;

    this.elements = {};
    this.index = [];
    this.openedPill = {}; // Trigger keybord use

    $(document).keyup(function (e) {
      // If escape key
      if (e.keyCode === 27) {
        // Then close all element in the opened elements array
        for (key in _oem.openedPill) {
          _oem.openedPill[key].close();

          delete _oem.openedPill[key];
        }
      }
    });
  }
  /**
   * Register new element
   * @param params
   */


  _createClass(openableElementsManager, [{
    key: "register",
    value: function register(params) {
      this.elements[params.identifier] = {
        // Status
        opened: false,
        // If element close the other on open
        closeAll: params.closeAll,
        // @TODO Close every elements in the same group
        closeByGroup: params.closeByGroup,
        // @TODO Stop closing elements after this closed
        closeStop: params.closeStop,
        // Pass the functions to open element
        openFunction: params.open,
        // Pass the function to close element
        closeFunction: params.close,
        // Open element
        open: function open() {
          this.opened = true;
          this.openFunction();
        },
        // Close element
        close: function close() {
          this.opened = false;
          this.closeFunction();
        }
      }; // Add to the elements array

      this.index[params.index] = this.elements[params.identifier];
    }
    /**
     * Open an element by is id
     * @param what
     */

  }, {
    key: "open",
    value: function open(what) {
      var _oem = this; // If element close the others


      if (this.elements[what].closeAll) {
        for (key in _oem.openedPill) {
          _oem.openedPill[key].close();

          delete _oem.openedPill[key];
        }
      }

      if (this.elements[what].closeByGroup) {}

      this.elements[what].open();
      this.openedPill[what] = this.elements[what];
    }
    /**
     * Close an element by his id
     * @param what
     */

  }, {
    key: "close",
    value: function close(what) {
      this.elements[what].close();
      delete this.openedPill[what];
    }
    /**
     * Toggle state of an element by his id
     * @param what
     */

  }, {
    key: "toggle",
    value: function toggle(what) {
      if (this.elements[what].opened) {
        this.close(what);
      } else {
        this.open(what);
      }
    }
    /*
        Get state of an element by his id
     */

  }, {
    key: "getState",
    value: function getState(what) {
      return this.elements[what].opened;
    }
  }]);

  return openableElementsManager;
}();
/*>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

/*          FRONT                                                  */

/*>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

/**
 *
 * @type {openableElementsManager}
 */


var openableElements = new openableElementsManager();
var keys = {
  37: 1,
  38: 1,
  39: 1,
  40: 1
};

function preventDefault(e) {
  e = e || window.event;
  if (e.preventDefault) e.preventDefault();
  e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}
/*

    Slick

 */


$('.images-container-images').slick({
  dots: false,
  arrows: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  asNavFor: '.images-navigation'
});
$('.images-navigation').slick({
  dots: false,
  prevArrow: '<i class="fas fa-chevron-circle-left arrow fa-2x previous"></i>',
  nextArrow: '<i class="fas fa-chevron-circle-right arrow fa-2x next"></i>',
  variableWidth: true,
  focusOnSelect: true,
  infinite: false,
  speed: 500,
  cssEase: 'linear',
  asNavFor: '.images-container-images'
});
$('.horizontal-listing').slick({
  variableWidth: true,
  prevArrow: '<i class="fas fa-chevron-circle-left arrow previous fa-4x"></i>',
  nextArrow: '<i class="fas fa-chevron-circle-right arrow next fa-4x"></i>',
  infinite: false
});
/* CUSTOMIZATION UI ELEMENT */

var UI =
/*#__PURE__*/
function () {
  function UI() {
    _classCallCheck(this, UI);

    var that = this;
    that.values = [];
    that.callbacks = [];
  }

  _createClass(UI, [{
    key: "set",
    value: function set(what, value) {
      var first = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var that = this;
      that.values[what] = value;

      if (!first) {
        for (var index in that.callbacks[what]) {
          if (that.callbacks[what].hasOwnProperty(index)) that.callbacks[what][index](that.values[what]);
        }
      }
    }
  }, {
    key: "get",
    value: function get(what) {
      var that = this;
      return that.values[what];
    }
  }, {
    key: "registerCallback",
    value: function registerCallback(forWhat, callback) {
      var that = this;

      if (typeof that.callbacks[forWhat] === 'undefined') {
        that.callbacks[forWhat] = [];
      }

      that.callbacks[forWhat].push(callback);
    }
  }]);

  return UI;
}();

var UI_values = new UI();
/* CUSTOMIZATION */
// Radio selectors

var radioSelectors = $('.radio-selector');
var radioSelectorElements = radioSelectors.find('.radio-selector-element');
radioSelectors.on('click', '.radio-selector-element', function () {
  var that = $(this);
  that.siblings().removeClass('active');
  that.addClass('active');
  UI_values.set(that.parent().data('id'), that.data('value'));
  setMarquageTarif();
}); // Color pickers

var colorPickers = $('.color-picker');
colorPickers.each(function () {
  var that = $(this);
  AColorPicker.from(that).on('change', function (picker) {
    UI_values.set(that.data('id'), picker.rgbhex);
  });
});
var inputElements = $('.ui-input');
inputElements.on('keyup', function () {
  var that = $(this);
  UI_values.set(that.data('id'), that.val());
});
inputElements.on('change', function () {
  var that = $(this);
  UI_values.set(that.data('id'), that.val());
});
inputElements.each(function (index, element) {
  var that = $(element);
  UI_values.set(that.data('id'), that.val(), true);
}); // SELECT

var selectorOpen = false;
$(document).on('click', '.selector-wrapper', function () {
  var that = $(this);

  if (!selectorOpen) {
    selectorOpen = that;
  } else {
    if (!this.isEqualNode(selectorOpen.get(0))) {
      selectorOpen.removeClass('opened');
      selectorOpen = false;
    }
  }

  if (that.hasClass('opened')) {
    selectorOpen = false;
    that.removeClass('opened');
  } else {
    selectorOpen = that;
    that.addClass('opened');
  }
});
$(document).on('click', '.selector-wrapper .selector-content', function (e) {
  e.stopPropagation();
});
$('.ui-select').each(function (key, element) {
  var that = $(this);
  var selectArray = {};
  that.find('.list-item').each(function (key, element) {
    var item = $(element);
    if (!item.hasClass('reinit')) selectArray[item.data('value')] = item.hasClass('selected');
  });
  UI_values.set(that.data('id'), selectArray);
});
$(document).on('click', '.ui-select .list-item', function () {
  var that = $(this);
  var selector = that.parent().parent().parent();
  var selectArray = UI_values.get(selector.data('id'));

  if (that.hasClass('reinit')) {
    for (var selectArrayItemKey in selectArray) {
      if (selectArray.hasOwnProperty(selectArrayItemKey)) selectArray[selectArrayItemKey] = false;
    }

    that.siblings().removeClass('selected');
  } else if (!selector.data('multiple')) {
    for (var _selectArrayItemKey in selectArray) {
      if (selectArray.hasOwnProperty(_selectArrayItemKey)) selectArray[_selectArrayItemKey] = false;
    }

    that.siblings().removeClass('selected');
    selectArray[that.data('value')] = true;
    that.toggleClass('selected');
  } else {
    if (selectArray[that.data('value')]) {
      selectArray[that.data('value')] = false;
    } else {
      selectArray[that.data('value')] = true;
    }

    that.toggleClass('selected');
  }

  UI_values.set(selector.data('id'), selectArray);
});
/*

    Search

 */

var searchContainer = $('#search-container');
var searchInput = $($('#search-container .search-input')[0]);
var searchResultsContainer = $($('#search-container .search-results-container')[0]);
var searchButton = $($('#search-container .search-button')[0]);
openableElements.register({
  identifier: 'site-search',
  closeAll: true,
  closeByGroup: false,
  open: function open() {
    searchContainer.fadeIn(150);
  },
  close: function close() {
    searchContainer.fadeOut(150);
  }
});
$('.menu-item.search').on('click', function () {
  openableElements.toggle('site-search');
});
$('.menu-item.catalogue').on('click', function () {
  href = $(this).data('href');
  window.location = href;
});
$('.menu-item.cart').on('click', function () {
  href = $(this).data('href');
  window.location = href;
});
searchContainer.on('click', function (e) {
  if (e.target !== this) {
    return;
  } else {
    openableElements.close('site-search');
  }
});
/*

    User menu

 */

var userMenu = $($('#right-menu .user-menu')[0]);
$(document).on('click', '.user-menu-switch-mode', function () {
  var that = $(this);

  if (userMenu.hasClass('create-account')) {
    userMenu.removeClass('create-account');
    userMenu.addClass('login');
  } else if (userMenu.hasClass('login')) {
    userMenu.removeClass('login');
    userMenu.addClass('create-account');
  }
});
/*

    Right menu

 */

var currentlyActiveMenu = '';
var rightMenu = {
  open: function open(what) {
    currentlyActiveMenu = what;
    openableElements.open('right-menu');
  },
  close: function close() {
    openableElements.close('right-menu');
  }
};
openableElements.register({
  identifier: 'right-menu',
  closeAll: false,
  closeByGroup: false,
  open: function open() {
    $('#right-menu').toggle();
    $('#right-menu .right-menu-item.item-' + currentlyActiveMenu).toggle();
  },
  close: function close() {
    $('#right-menu').toggle();
    $('#right-menu .right-menu-item.item-' + currentlyActiveMenu).toggle();
  }
});
$(document).on('click', '.open-right-menu', function () {
  var that = $(this);
  currentlyActiveMenu = that.data('target-menu');
  openableElements.toggle('right-menu');
});
$(document).on('click', '#right-menu', function (e) {
  if (e.target !== this) {
    return;
  } else {
    openableElements.toggle('right-menu');
  }
});
$(document).on('click', '#right-menu .right-menu-content', function (e) {
  e.stopPropagation();
});
$(document).on('click', '#right-menu .close-button', function () {
  openableElements.toggle('right-menu');
});
/*

    Lang selector

 */

$('.locale-selector').on('click', function () {
  var that = $(this);
  that.toggleClass('opened');
});
$('.open-popup').on('click', function (e) {
  e.preventDefault();
  var that = $(this);
  var win = window.open(that.attr('href'), 'Account', 'width=1200,height=600');
  var timer = setInterval(function () {
    if (win.closed) {
      clearInterval(timer);
      window.location.reload();
    }
  }, 200);
});

function getAllUrlParams(url) {
  // get query string from url (optional) or window
  var queryString = url ? url.split('?')[1] : window.location.search.slice(1); // we'll store the parameters here

  var obj = {}; // if query string exists

  if (queryString) {
    // stuff after # is not part of query string, so get rid of it
    queryString = queryString.split('#')[0]; // split our query string into its component parts

    var arr = queryString.split('&');

    for (var i = 0; i < arr.length; i++) {
      // separate the keys and the values
      var a = arr[i].split('='); // set parameter name and value (use 'true' if empty)

      var paramName = a[0];
      var paramValue = typeof a[1] === 'undefined' ? true : a[1]; // (optional) keep case consistent

      paramName = paramName.toLowerCase();
      if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase(); // if the paramName ends with square brackets, e.g. colors[] or colors[2]

      if (paramName.match(/\[(\d+)?\]$/)) {
        // create key if it doesn't exist
        var key = paramName.replace(/\[(\d+)?\]/, '');
        if (!obj[key]) obj[key] = []; // if it's an indexed array e.g. colors[2]

        if (paramName.match(/\[\d+\]$/)) {
          // get the index value and add the entry at the appropriate position
          var index = /\[(\d+)\]/.exec(paramName)[1];
          obj[key][index] = paramValue;
        } else {
          // otherwise add the value to the end of the array
          obj[key].push(paramValue);
        }
      } else {
        // we're dealing with a string
        if (!obj[paramName]) {
          // if it doesn't exist, create property
          obj[paramName] = paramValue;
        } else if (obj[paramName] && typeof obj[paramName] === 'string') {
          // if property does exist and it's a string, convert it to an array
          obj[paramName] = [obj[paramName]];
          obj[paramName].push(paramValue);
        } else {
          // otherwise add the property
          obj[paramName].push(paramValue);
        }
      }
    }
  }

  return obj;
}

var Url =
/*#__PURE__*/
function () {
  function Url() {
    _classCallCheck(this, Url);

    var _Url = this;

    _Url.url = window.location.protocol + '//' + window.location.host + window.location.pathname;
    _Url.params = [];

    _Url.paramParse();
  }

  _createClass(Url, [{
    key: "paramParse",
    value: function paramParse() {
      var _Url = this;

      var params = getAllUrlParams();

      for (var param in params) {
        if (Array.isArray(params[param])) {
          _Url.params[param] = params[param];
        } else {
          _Url.params[param] = [params[param]];
        }
      }
    }
  }, {
    key: "paramGet",
    value: function paramGet(what) {
      var _Url = this;

      return _Url.params[what];
    }
  }, {
    key: "paramSet",
    value: function paramSet(what) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var _Url = this;

      _Url.params[what] = [];

      if (value) {
        _Url.params[what].push(value);
      }
    }
  }, {
    key: "paramAppend",
    value: function paramAppend(what, value) {
      var _Url = this;

      _Url.params[what].push(value);
    }
  }, {
    key: "paramRemoveContain",
    value: function paramRemoveContain(what) {
      var _Url = this;

      for (var param in _Url.params) {
        if (!_Url.params.hasOwnProperty(param)) continue;

        if (param.indexOf(what) !== -1) {
          delete _Url.params[param];
        }
      }
    }
  }, {
    key: "build",
    value: function build() {
      var _Url = this;

      var fullUrl = _Url.url;

      if (Object.keys(_Url).length > 0) {
        fullUrl += '?';
      }

      var paramFirst = true;

      var _loop = function _loop(param) {
        if (!_Url.params.hasOwnProperty(param)) return "continue";
        if (_Url.params[param].length === 0) return "continue";

        if (!paramFirst) {
          fullUrl += '&';
        } else {
          paramFirst = false;
        }

        fullUrl += param + '=';
        var paramValueFirst = true;

        _Url.params[param].forEach(function (elem, key) {
          if (!paramValueFirst) {
            fullUrl += ',';
          } else {
            paramValueFirst = false;
          }

          fullUrl += elem;
        });
      };

      for (var param in _Url.params) {
        var _ret = _loop(param);

        if (_ret === "continue") continue;
      }

      return fullUrl;
    }
  }]);

  return Url;
}();

var URL = new Url();

var applyFilters = function applyFilters() {
  var queryString = window.location.protocol + '//' + window.location.host + window.location.pathname;
  var params = getAllUrlParams();
  var existingFilters = {};

  for (var param in params) {
    if (!params.hasOwnProperty(param)) continue;

    if (param.startsWith('filter_')) {
      existingFilters[param] = params[param];
    }
  }

  ['filter_category', 'filter_price_min', 'filter_price_max'].forEach(function (filter) {
    if ((filter === 'filter_price_min' || filter === 'filter_price_max') && !logged) {
      return;
    }

    var selectArray = UI_values.get(filter);
    URL.paramSet(filter);

    if (filter === 'filter_price_min' || filter === 'filter_price_max') {
      if (parseInt(selectArray) !== 0 && parseInt(selectArray) !== 200) {
        URL.paramAppend(filter, selectArray);
      }
    } else {
      for (var selectArrayItemKey in selectArray) {
        if (selectArray.hasOwnProperty(selectArrayItemKey) && selectArray[selectArrayItemKey]) {
          URL.paramAppend(filter, selectArrayItemKey);
        }
      }
    }
  });
  console.log(URL.build());
  window.location.href = URL.build();
};

UI_values.registerCallback('filter_category', function () {
  applyFilters();
});
UI_values.registerCallback('filter_price_min', function () {
  applyFilters();
});
UI_values.registerCallback('filter_price_max', function () {
  applyFilters();
});
$('.filters-reinit').on('click', function () {
  URL.paramRemoveContain('filter_');
  window.location.replace(URL.build());
});
$('.active-filter').on('click', function () {
  var that = $(this);
  var param = URL.paramGet(that.data('filter'));
  param = param[0].replace(that.data('value'), '').replace(',,', ',');

  if (param.charAt(0) === ',') {
    param = param.substring(1);
  }

  if (param.charAt(param.length - 1) === ',') {
    param = param.substring(0, param.length - 1);
  }

  URL.paramSet(that.data('filter'), param);
  window.location.href = URL.build();
});
var customisationMenu = $('.customisation-menu')[0];

$.fn.slideFadeToggle = function (speed, easing, callback) {
  return this.animate({
    opacity: 'toggle',
    height: 'toggle'
  }, speed, easing, callback);
};

var menuItems = $('.customisation-menu .menu-item');
var subMenuItems = $('.customisation-sub-menu .sub-menu-item');
menuItems.on('click', function (e) {
  var that = $(this);
  e.stopPropagation();

  if (!that.hasClass('reset') && !that.hasClass('disabled')) {
    if (!that.hasClass('active')) {
      menuItems.removeClass('active');
      that.addClass('active');
      subMenuItems.hide();
      $('.customisation-sub-menu .sub-menu-item.' + that.data('category')).show();
    }
  }
});
subMenuItems.on('click', function () {
  var that = $(this);
  that.find('.sub-menu-item-body').slideFadeToggle(200);
  that.toggleClass('opened');
});
subMenuItems.find('.sub-menu-item-body').on('click', function (e) {
  e.stopPropagation();
});
subMenuItems.each(function () {
  var that = $(this);

  if (that.hasClass('opened')) {
    that.find('.sub-menu-item-body').slideFadeToggle(200);
  }
});

function setMarquageTarif() {
  var val = $("#marquagequantite").val();
  var tech = UI_values.values['marking_technology'] || undefined;
  var zone = UI_values.values['marking_zone'] || undefined;
  console.log(val, tech, zone);

  if (tech != undefined && zone != undefined) {
    $("#selectmark").hide(); // Check minimum quantity

    var minquantity = undefined;

    for (i in personnalisations) {
      if (personnalisations[i].emplacement_id == zone && personnalisations[i].marquage_id == tech) {
        if (minquantity == undefined || personnalisations[i].qtemin < minquantity) minquantity = personnalisations[i].qtemin;
      }
    }

    if (minquantity > $("#marquagequantite").val()) {
      $("#validatemarkingbtn").attr('disabled', true);
      $("#qtemin").html(minquantity);
      $("#textqtemin").show();
      $("#marquageprice").html('-- €');
      $("#prodpriceoption").html('--');
      $("#custtotal").html('--');
      $("#validatemarkingbtn").attr('disabled', true);
    } else {
      var price = 9999999;
      var persoid = undefined;

      for (i in personnalisations) {
        if (personnalisations[i].emplacement_id == zone && personnalisations[i].marquage_id == tech && personnalisations[i].qtemin <= val) {
          price = personnalisations[i].price;
          persoid = personnalisations[i].id;
        }
      }

      var productprice = 999999;

      for (var _i2 = 0; _i2 < tarifsproduit.length; _i2++) {
        if (tarifsproduit[_i2].min <= val) productprice = tarifsproduit[_i2].tarif;
      }

      price = parseFloat(price);
      productprice = parseFloat(productprice);
      $("#marquageprice").html(price.toLocaleString('fr') + ' €');
      $("#prodpriceoption").html((productprice + price).toLocaleString('fr'));
      $("#custtotal").html(((productprice + price) * val).toLocaleString('fr'));
      $("#persoid").val(persoid);
      $("#persoqte").val(val);
      $("#textqtemin").hide();
      $("#validatemarkingbtn").attr('disabled', false);
    }
  } else {
    $("#marquageprice").html('-- €');
    $("#prodpriceoption").html('--');
    $("#custtotal").html('--');
    $("#validatemarkingbtn").attr('disabled', true);
    $("#textqtemin").hide();
    $("#selectmark").show();
  }
}

$(".product-quantity-input").change(function (e) {
  setMarquageTarif();
});
$(".marquagedecliqte").change(function (e) {
  var total = 0;
  $(".marquagedecliqte").each(function (e) {
    total += parseInt($(this).val());
    var id = $(this).data('decliid');
    $("#decliid_" + id).val(parseInt($(this).val()));
  });
  $(".product-quantity-input").val(total);
  setMarquageTarif();
});
//# sourceMappingURL=front.js.map